// extracted by mini-css-extract-plugin
module.exports = {"container":"DocNumber_container__2ygfi"};